import React from "react";
import { FiSidebar } from "react-icons/fi";

interface NewChatButtonProps {
  setHistoryData: React.Dispatch<React.SetStateAction<any[]>>;
  setMessageList: React.Dispatch<React.SetStateAction<any[]>>;
  mindAgentData: any;
  setSelectedAgent: React.Dispatch<React.SetStateAction<string | null>>;
  setSelectedModel: React.Dispatch<React.SetStateAction<string>>;
  setSelectedAgentId: React.Dispatch<React.SetStateAction<string | null>>;
  setSelectedTag: any;
  setSelectedTagName: React.Dispatch<React.SetStateAction<string>>;
  setPdfName: any;
  setInputMessage: React.Dispatch<React.SetStateAction<string>>;
  setGroupSelected: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchEngine: any;
  setSelectedRoomId: React.Dispatch<React.SetStateAction<number>>;
  setCustomInstructions: React.Dispatch<React.SetStateAction<any>>;
  setUserInstructions: React.Dispatch<React.SetStateAction<any>>;
  setCustomInstructionsName: React.Dispatch<React.SetStateAction<string>>;
  setUserInstructionsName: React.Dispatch<React.SetStateAction<string>>;
  setFile: React.Dispatch<React.SetStateAction<File | null>>;
  setShowPreview: React.Dispatch<React.SetStateAction<boolean>>;
  setShowCodeModal: React.Dispatch<React.SetStateAction<boolean>>;
  setPreviewContent: React.Dispatch<React.SetStateAction<string>>;
  setSqlCode: React.Dispatch<React.SetStateAction<string>>;
  setGraphCode: React.Dispatch<React.SetStateAction<string>>;
  setVersions: React.Dispatch<React.SetStateAction<any[]>>;
  versionCounter: React.MutableRefObject<number>;
  setActiveVersionNumber: any;
  sidebarVisible: boolean;
  toggleSidebar: any;
  setSelectedXsdPath: any;
  setXsdPathConditions: any;
  setSelectedXsdId: React.Dispatch<React.SetStateAction<string>>;
  setXsdXml: React.Dispatch<React.SetStateAction<string>>;
  setTreeData: any;
}

const NewChatButton: React.FC<NewChatButtonProps> = ({
  setHistoryData,
  setMessageList,
  mindAgentData,
  setSelectedAgent,
  setSelectedModel,
  setSelectedAgentId,
  setSelectedTag,
  setSelectedTagName,
  setPdfName,
  setInputMessage,
  setGroupSelected,
  setSearchEngine,
  setSelectedRoomId,
  setCustomInstructions,
  setUserInstructions,
  setCustomInstructionsName,
  setUserInstructionsName,
  setFile,
  setShowPreview,
  setShowCodeModal,
  setPreviewContent,
  setSqlCode,
  setGraphCode,
  setVersions,
  versionCounter,
  setActiveVersionNumber,
  sidebarVisible,
  toggleSidebar,
  setSelectedXsdPath,
  setXsdPathConditions,
  setSelectedXsdId,
  setXsdXml,
  setTreeData,
}) => {
  const handleNewChat = () => {
    setHistoryData([]);
    setMessageList([]);
    setSelectedAgent(mindAgentData && mindAgentData[0].agent);
    setSelectedModel("boxMind");
    setSelectedAgentId(mindAgentData && mindAgentData[0].id);
    setSelectedTag("");
    setSelectedTagName("");
    setPdfName("");
    setInputMessage("");
    setGroupSelected(false);
    setSearchEngine("0");
    setSelectedRoomId(Math.round(Math.random() * 1e9));
    setCustomInstructions(null);
    setUserInstructions(null);
    setCustomInstructionsName("");
    setUserInstructionsName("");
    setFile(null);
    setShowPreview(false);
    setShowCodeModal(false);
    setPreviewContent("");
    setSqlCode("");
    setGraphCode("");
    setVersions([]);
    versionCounter.current = 1;
    setActiveVersionNumber(1);
    setSelectedXsdPath(null);
    setXsdPathConditions([]);
    setSelectedXsdId("");
    setXsdXml("");
    setTreeData(null);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleNewChat}
        type="button"
        className={`w-full lg:h-[30px] h-[40px] rounded-md bg-[#20144C] text-white hover:bg-[#45328b] duration-300 ${
          sidebarVisible ? "" : "hidden"
        }`}
      >
        + New Chat
      </button>
      <div className={`relative ${sidebarVisible ? "" : " p-4"}`}>
        <button
          type="button"
          onClick={toggleSidebar}
          className={`lg:h-[30px] h-[40px] px-2 hover:bg-[#45328b] text-white duration-300 rounded-md ${
            sidebarVisible ? " bg-[#20144C] text-white " : "bg-[#20144C]"
          }`}
        >
          <FiSidebar size={20} />
        </button>
      </div>
    </div>
  );
};

export default NewChatButton;
